import { TARGET_COUNT } from '@shared/game/constants';
import { t } from '../i18n/ru';
import { useController } from '../state/context';
import { Gem } from './Icons';

/** Сколько своих слов уже открыто: видимый прогресс к цели мотивирует «дожать» последнее слово. */
export function Goal() {
  const game = useController().game.value;
  if (!game) return null;
  const found = game.roles.filter((role, i) => role === 't' && game.revealed[i]).length;
  return (
    <div class="goal" data-testid="goal" role="img" aria-label={t.goal(found, TARGET_COUNT)}>
      {Array.from({ length: TARGET_COUNT }, (_, k) => (
        <Gem key={`${game.id}-${k}`} class={k < found ? 'gem on' : 'gem'} />
      ))}
      <span class="cnt">
        <b>{found}</b> / {TARGET_COUNT}
      </span>
    </div>
  );
}
